import state from './moduleProgressState'
import mutations from './moduleProgressMutations'
import actions from './moduleProgressActions'
import getters from './moduleProgressGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}